module.exports = __webpack_public_path__ + "static/media/save-check.5f6ffb14.svg";